import './ReferralQuestion.scss'

import React, {Component} from 'react'
import {
  TITLE_DO_YOU_KNOW_PROVIDER_CHOICES, ANSWER_TYPE, QUESTION_TYPE,
} from 'common/constants'
import cx from 'classnames'
import {connect} from 'react-redux'
import {createStructuredSelector} from "reselect"

import {
  selectTitleDoYouKnowProviderQuestion,
} from "manager/selectors/referral_selectors"
import {updateAgentTitleQuestions} from "manager/redux/referral"

class ReferralQuestionTitleDoYouKnowProvider extends Component {

  handleOnClick = (value) => {
    const {updateAgentTitleQuestions} = this.props
    updateAgentTitleQuestions({[QUESTION_TYPE.TITLE_DO_YOU_KNOW_PROVIDER]: {[ANSWER_TYPE.YES_NO]: value}})
  }

  render() {
    const {titleDoYouKnowProviderAnswer} = this.props
    return (
      <div className="ReferralQuestion">
        <div className="question">Do you know your title provider?</div>
        <div className="choice-btns">
          {TITLE_DO_YOU_KNOW_PROVIDER_CHOICES.map(({label, value}) => (
            <button
              key={value}
              onClick={() => this.handleOnClick(value)}
              className={cx('StatusChoice', {
                'StatusChoice__selected': titleDoYouKnowProviderAnswer && titleDoYouKnowProviderAnswer[ANSWER_TYPE.YES_NO] === value
              })}>
              {label}
            </button>
          ))}
        </div>
      </div>
    )
  }

}

const selector = createStructuredSelector({
  titleDoYouKnowProviderAnswer: selectTitleDoYouKnowProviderQuestion,
})

const actions = {
  updateAgentTitleQuestions
}

export default connect(selector, actions)(ReferralQuestionTitleDoYouKnowProvider)
